module.exports = __webpack_public_path__ + "static/img/Cardfooter01.65befa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter01.png
// module id = vMsZ
// module chunks = 1